module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app-price-widget"
    }
  }, [_c('div', {
    staticClass: "widget-wrapper"
  }, [_c('div', {
    staticClass: "widget"
  }, [_c('div', [_c('div', {
    staticClass: "widget-label",
    staticStyle: {
      "padding-bottom": "0"
    }
  }, [_vm._v("\n          Phone number\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.number),
      expression: "number"
    }],
    staticClass: "widget-input",
    attrs: {
      "type": "text",
      "placeholder": "+44-742-000-00-00"
    },
    domProps: {
      "value": (_vm.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.number = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "widget-label"
  }, [_vm._v("Crypto currency")]), _vm._v(" "), _c('button-list', {
    attrs: {
      "list": _vm.cryptoOptions
    },
    on: {
      "select": _vm.selectCrypto
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "widget-label"
  }, [_vm._v("Fiat currency")]), _vm._v(" "), _c('button-list', {
    attrs: {
      "list": _vm.fiatOptions
    },
    on: {
      "select": _vm.selectFiat
    }
  })], 1), _vm._v(" "), _c('button', {
    class: ['widget-button', {
      blocked: _vm.waiting,
      large: true
    }],
    on: {
      "click": _vm.click
    }
  }, [_vm._v("\n      " + _vm._s(_vm.waiting ? "Sending..." : "Send price in SMS") + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b80fdcda","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 37
// module chunks = 0